import styles from './DefaultIconButton.module.scss';

import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '../tooltip/Tooltip';

type Props = {
  isDefault: boolean;
  disabled: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const DefaultIconButton = ({ isDefault, disabled, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={
        isDefault
          ? t('INPUTS.REMOVE_GLOBAL_STANDART')
          : t('INPUTS.SET_GLOBAL_STANDART')
      }
    >
      <IconButton
        className={clsx(styles.button, {
          [styles.isDefault]: isDefault,
        })}
        onClick={onClick}
        disabled={disabled}
      >
        {isDefault ? <RadioButtonChecked /> : <RadioButtonUnchecked />}
      </IconButton>
    </Tooltip>
  );
};
